import { get } from 'lodash';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { Response } from 'store/global/types';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
import { getOrganizationsFail, getOrganizationsSuccess } from './actions';
import api from './apis';
import { GET_ORGANIZATIONS_ACTIONS } from './constants';

export function* getOrganizations() {
  try {
    const language: string = yield select(getLocaleSelector);
    const response: Response = yield call(api.getOrganizations, language);

    if (get(response, 'data.success', false)) {
      yield put(getOrganizationsSuccess(get(response, 'data.data', [])));
    } else {
      yield put(getOrganizationsFail(response.data));
    }
  } catch (error) {
    yield put(getOrganizationsFail(error));
  }
}

export function* watchGetOrganizations() {
  yield takeLatest(GET_ORGANIZATIONS_ACTIONS.START, getOrganizations);
}

export default [watchGetOrganizations];
